module.exports = __webpack_public_path__ + "img/2.4ed4f0d9.jpg";